import React, { useState, useEffect } from "react";
import {
  makeStyles,
  RadioGroup,
  Radio,
  Text,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  Spinner,
} from "@fluentui/react-components";
import { getMailboxAttachments, createDocumentFromAttachment, isReadMode } from "../../utils/OfficeApiHelper";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  text: {
    margin: "0",
  }
});

const DocumentSelection = ({ onReady }) => {
  const styles = useStyles();
  const [loading, setLoading] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const isRead = isReadMode();

  useEffect(() => {
    const data = getMailboxAttachments();
    setAttachments(data);
    setLoading(false);
  }, []);

  const handleAttachmentSelection = async (_ev, data) => {
    const attachmentId = data?.value || "";
    try {
      const attachmentDocument = await createDocumentFromAttachment(attachmentId, attachments);

      if (!attachmentDocument) {
        throw new Error("Failed to create document from attachment");
      }

      onReady(attachmentDocument);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className={styles.container}>
        {loading ? (
          <Spinner />
        ) : !isRead ? (
          <MessageBar intent="warning">
            <MessageBarBody>
              <Text as="p" block className={styles.text}>
                Documents are only available in read mode
              </Text>
            </MessageBarBody>
          </MessageBar>
        ) : attachments.length > 0 ? (
          <div className={styles.row}>
              <RadioGroup>
                {attachments.map((attachment, index) => (
                  <Radio
                    key={index}
                    value={attachment.id}
                    label={attachment.name}
                    onChange={handleAttachmentSelection}
                  />
                ))}
              </RadioGroup>
            </div>
        ) : (
          <MessageBar intent="warning">
            <MessageBarBody>
              <MessageBarTitle>Documents not found</MessageBarTitle>
              <Text as="p" block className={styles.text}>
                This email does not contain any documents
              </Text>
            </MessageBarBody>
          </MessageBar>
        )}
      </div>
    </>
  );
};

export default DocumentSelection;
